import { MemberProfile } from "@/services/core-api-adapter";
import B2BMemberDashboard from ".";
import { Stack, Typography } from "@mui/material";
import {
  defaultFullscreenPageStyling,
  pageWithBottomNavigationStyling,
} from "@/theme";

export default function B2BMemberDashboardExamples() {
  return (
    <Stack spacing={4}>
      <Typography>Default</Typography>
      <Stack
        sx={{
          ...defaultFullscreenPageStyling,
          ...pageWithBottomNavigationStyling,
          position: "relative",
        }}
      >
        <B2BMemberDashboard
          isMemberProfileLoading={false}
          memberProfileFetchError={false}
          memberProfile={
            {
              firstName: "Lesedi",
              consultation: {
                consultationResponses: [],
                consultationRates: [],
              },
              memberServiceOfferingUsageCount: "1",
              unlimited: false,
              healthProfile: {
                lastUpdatedAt: "2022-07-08T10:26:04Z",
                healthScoreValue: 75,
              },
              benefitCount: 11,
              dependentCount: 1,
              membership: {
                id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
                fullName: "Lesedi",
                beneficiaryCode: "00",
                productCode: "PRIST",
                productFriendlyName: "BEWELL 101",
                membershipNumber: "UNU-725",
                dependentCount: 7,
              },
              product: {
                pharmacySwitchCode: "E1200ED",
                provider: {
                  id: "b958fa21-4fd4-49d3-9a07-ed33b314538e",
                  name: "Genric",
                  description: null,
                  imageUri: "{{STATIC_PLACEHOLDER_IMAGE_URI}}",
                },
                administrator: {
                  id: "bbb82cc0-9ea1-40be-8cb2-80e3bbdf7b61",
                  code: "NHG",
                  name: "National Health Group",
                  FileUri: "{{STATIC_PLACEHOLDER_DOCUMENT_URI}}",
                  timeZone: "UTC+02:00",
                  supportedServices: [
                    {
                      type: "CALL_CENTRE",
                      channels: [
                        {
                          type: "PHONE",
                          value: "+27860222286",
                          availability: [
                            {
                              day: "MONDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "TUESDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "WEDNESDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "THURSDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "FRIDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "SATURDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                            {
                              day: "SUNDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                            {
                              day: "HOLIDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                          ],
                        },
                        {
                          type: "EMAIL",
                          value: "test@test.com",
                          availability: [],
                        },
                        {
                          type: "WHATSAPP",
                          value: null,
                          availability: [],
                        },
                      ],
                    },
                  ],
                },
              },
            } as unknown as MemberProfile
          }
        />
      </Stack>
      <Typography>Loading</Typography>
      <Stack
        sx={{
          ...defaultFullscreenPageStyling,
          ...pageWithBottomNavigationStyling,
          position: "relative",
        }}
      >
        <B2BMemberDashboard
          isMemberProfileLoading={true}
          memberProfileFetchError={false}
          memberProfile={
            {
              firstName: "Lesedi",
              consultation: {
                consultationResponses: [],
                consultationRates: [],
              },
              memberServiceOfferingUsageCount: "1",
              unlimited: false,
              healthProfile: {
                lastUpdatedAt: "2022-07-08T10:26:04Z",
                healthScoreValue: 75,
              },
              benefitCount: 11,
              dependentCount: 1,
              membership: {
                id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
                fullName: "Lesedi",
                beneficiaryCode: "00",
                productCode: "PRIST",
                productFriendlyName: "BEWELL 101",
                membershipNumber: "UNU-725",
                dependentCount: 7,
              },
              product: {
                pharmacySwitchCode: "E1200ED",
                provider: {
                  id: "b958fa21-4fd4-49d3-9a07-ed33b314538e",
                  name: "Genric",
                  description: null,
                  imageUri: "{{STATIC_PLACEHOLDER_IMAGE_URI}}",
                },
                administrator: {
                  id: "bbb82cc0-9ea1-40be-8cb2-80e3bbdf7b61",
                  code: "NHG",
                  name: "National Health Group",
                  FileUri: "{{STATIC_PLACEHOLDER_DOCUMENT_URI}}",
                  timeZone: "UTC+02:00",
                  supportedServices: [
                    {
                      type: "CALL_CENTRE",
                      channels: [
                        {
                          type: "PHONE",
                          value: "+27860222286",
                          availability: [
                            {
                              day: "MONDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "TUESDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "WEDNESDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "THURSDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "FRIDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "SATURDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                            {
                              day: "SUNDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                            {
                              day: "HOLIDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                          ],
                        },
                        {
                          type: "EMAIL",
                          value: "test@test.com",
                          availability: [],
                        },
                        {
                          type: "WHATSAPP",
                          value: null,
                          availability: [],
                        },
                      ],
                    },
                  ],
                },
              },
            } as unknown as MemberProfile
          }
        />
      </Stack>
      <Typography>Member profile error</Typography>
      <Stack
        sx={{
          ...defaultFullscreenPageStyling,
          ...pageWithBottomNavigationStyling,
          position: "relative",
        }}
      >
        <B2BMemberDashboard
          isMemberProfileLoading={false}
          memberProfileFetchError={true}
          memberProfile={
            {
              firstName: "Lesedi",
              consultation: {
                consultationResponses: [],
                consultationRates: [],
              },
              memberServiceOfferingUsageCount: "1",
              unlimited: false,
              healthProfile: {
                lastUpdatedAt: "2022-07-08T10:26:04Z",
                healthScoreValue: 75,
              },
              benefitCount: 11,
              dependentCount: 1,
              membership: {
                id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
                fullName: "Lesedi",
                beneficiaryCode: "00",
                productCode: "PRIST",
                productFriendlyName: "BEWELL 101",
                membershipNumber: "UNU-725",
                dependentCount: 7,
              },
              product: {
                pharmacySwitchCode: "E1200ED",
                provider: {
                  id: "b958fa21-4fd4-49d3-9a07-ed33b314538e",
                  name: "Genric",
                  description: null,
                  imageUri: "{{STATIC_PLACEHOLDER_IMAGE_URI}}",
                },
                administrator: {
                  id: "bbb82cc0-9ea1-40be-8cb2-80e3bbdf7b61",
                  code: "NHG",
                  name: "National Health Group",
                  FileUri: "{{STATIC_PLACEHOLDER_DOCUMENT_URI}}",
                  timeZone: "UTC+02:00",
                  supportedServices: [
                    {
                      type: "CALL_CENTRE",
                      channels: [
                        {
                          type: "PHONE",
                          value: "+27860222286",
                          availability: [
                            {
                              day: "MONDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "TUESDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "WEDNESDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "THURSDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "FRIDAY",
                              operatingHours: "08:00 - 20:00",
                            },
                            {
                              day: "SATURDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                            {
                              day: "SUNDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                            {
                              day: "HOLIDAY",
                              operatingHours: "08:00 - 18:00",
                            },
                          ],
                        },
                        {
                          type: "EMAIL",
                          value: "test@test.com",
                          availability: [],
                        },
                        {
                          type: "WHATSAPP",
                          value: null,
                          availability: [],
                        },
                      ],
                    },
                  ],
                },
              },
            } as unknown as MemberProfile
          }
        />
      </Stack>
    </Stack>
  );
}
